/**
 * Production tuning constants (shipped to patients — NOT debug flags).
 *
 * Sensor-artifact rejection for the RR / HR vital charts: an hour is treated as
 * a sensor artifact (and erased from hourly views) unless it contains at least
 * VALID_MINUTES_PER_HOUR minutes that each have at least
 * VALID_POINTS_PER_MINUTE raw 3-second data points.
 *
 * The filter is applied client-side in cdlRepository (see dropArtifactHours /
 * annotateArtifactHours). It deliberately lives outside cdlapi, which is
 * FDA-locked and must not change.
 */

/** A minute "counts" only if it has at least this many raw 3s data points. */
export const VALID_POINTS_PER_MINUTE = 2;

/** An hour is kept only if it has at least this many counting minutes. */
export const VALID_MINUTES_PER_HOUR = 5;

/** Production RR / HR normal ranges live in:
 *  PatientApp-Web/src/constants/vitalThresholds.ts
 */

/** Show prev/next day arrows on the respiratory-rate detail view's Day (D)
 *  tab so users can page back through the last ~7 days of hourly RR readings
 *  (one calendar day at a time). */
export const SHOW_RR_DAILY_HISTORY = true;

/** Show prev/next day arrows on the heart-rate detail view's Day (D) tab so
 *  users can page back through the last ~7 days of hourly HR readings (one
 *  calendar day at a time). */
export const SHOW_HR_DAILY_HISTORY = true;
